import styled from 'styled-components';

const List = styled.section`
  color: #5a5f6a;
  font-size: 14px;
  line-height: 22px;
`;

export default List;
